<terra-dialog-header>
    <h1>
      Confirm Uploaded File
    </h1>
  </terra-dialog-header>
  
  <mat-dialog-content>
    <h3 class="description">{{documentType | enumString : UnitDocumentType}} - {{ documentDescription }}</h3>
    <div class="file-previews">
      <!-- Front side -->
      <div class="front-side">
        <h4 *ngIf="hasBackSide" class="side-name">Front side</h4>
        <img [src]="fileUrlFront" *ngIf="fileTypeFront === 'image'">
        <embed [src]="fileUrlFront" width="400px" height="500px" *ngIf="fileTypeFront === 'pdf'"  type="application/pdf"
          toolbar="0" navpanes="0" statusbar="0" zoom="fit" />
        <span class="file-name truncate-to-width">{{ fileNameFront }}</span>
      </div>
      <!-- Back side -->
      <div class="back-side" *ngIf="hasBackSide">
        <h4 class="side-name">Back side</h4>
        <img [src]="fileUrlBack" *ngIf="fileTypeBack === 'image'">
        <embed [src]="fileUrlBack" width="400px" height="500px" *ngIf="fileTypeBack === 'pdf'"  type="application/pdf"
          toolbar="0" navpanes="0" statusbar="0" zoom="fit" />
        <span class="file-name truncate-to-width">{{ fileNameBack }}</span>
      </div>
    </div>
  </mat-dialog-content>
  
  <div mat-dialog-actions>
    <!-- cdkFocusInitial -->
    <button mat-flat-button color="primary" (click)="confirm()">
      Confirm
    </button>
    <button [mat-dialog-close]="false" type="button" mat-button aria-label="Reject" class="reject-button">
      Reject
    </button>
  </div>
  